module.exports = __webpack_public_path__ + "img/0Q3A5468_L_Foamcore_MockedUp.dffe57a4.jpg";